import React, { useEffect, useState, useCallback } from 'react';
import NotPushAuth from 'NotPushAuth';
import {
  SectionWrapper,
  Title,
  Text,
  ScrollItem,
  Scroll,
  GridList,
  BoldText,
} from 'assets/GlobalLayoutStyle';
import { PostCard } from 'components/PostProduct';
import { db } from 'firebase/index';
import { PrimaryButton, ImageStyleChangeIcon } from 'components/UI';
import { POST } from 'types/posts';
import HowToVoteIcon from '@material-ui/icons/HowToVote';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';

const Contest = ({ top }) => {
  const [postsList, setPostsList] = useState<POST[]>([]);
  const [change, setChange] = useState<boolean>(false);

  useEffect(() => {
    db.collection('posts')
      .where('contest', '==', '金魚')
      .orderBy('contestCount', 'desc')
      .get()
      .then((snapshot) => {
        const list = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          list.push(data);
        });
        setPostsList(list);
      });
  }, []);

  return (
    <SectionWrapper>
      {!top && (
        <>
          <NotPushAuth />
          <div className="module-spacer--small" />
          <HowToVoteIcon style={{ fontSize: '60px' }} color="action" />
          <Title>コンテスト</Title>
          <Text>
            ただいま金魚コンテスト開催中！
            <br />
            まだ決まっていませんが選ばれた方には景品も考えているので、どしどしご応募くださいませ！
          </Text>
          <div className="module-spacer--medium" />
          <ImageStyleChangeIcon setChange={setChange} />
          <div className="module-spacer--medium" />
        </>
      )}

      {!top && (
        <GridList contest change={change}>
          {postsList.length > 0 ? (
            postsList.map((post) => (
              <ScrollItem key={post.id}>
                <PostCard
                  change={change}
                  post={post}
                  key={post.id}
                  name={post.name}
                  images={post.images}
                  allImages={post.allImages}
                  id={post.id}
                  description={post.description}
                  username={post.username}
                  avatar={post.avatar}
                  uid={post.uid}
                  vote
                />
              </ScrollItem>
            ))
          ) : (
            // ローディング中の表示
            <></>
          )}
        </GridList>
      )}
      {top && (
        <Scroll>
          {postsList.length > 0 ? (
            postsList.map((post) => (
              <ScrollItem width key={post.id}>
                <PostCard
                  post={post}
                  key={post.id}
                  name={post.name}
                  images={post.images}
                  allImages={post.allImages}
                  id={post.id}
                  description={post.description}
                  username={post.username}
                  avatar={post.avatar}
                  uid={post.uid}
                />
              </ScrollItem>
            ))
          ) : (
            <>
              <div className="module-spacer--small" />
              <InsertEmoticonIcon style={{ fontSize: '60px' }} color="action" />
              <BoldText color={'dimgray'}>ただいま募集中です！</BoldText>
            </>
          )}
        </Scroll>
      )}
    </SectionWrapper>
  );
};

export default Contest;
